import React from 'react';
import { Helmet } from 'react-helmet-async';

function SeoDefaults() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Clariti AI',
    url: 'https://www.clariti.ai/',
    logo: 'https://www.clariti.ai/images/logos/logo_brain_white_bg.png',
    sameAs: [
      'https://www.linkedin.com/company/claritiai/',
      'https://x.com/claritiai',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'sales',
      email: 'info@clariti.ai',
      areaServed: 'Worldwide',
      availableLanguage: 'English',
    },
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Clariti AI',
    url: 'https://www.clariti.ai/',
    inLanguage: 'en-GB',
  };

  return (
    <Helmet>
      <meta property="og:site_name" content="Clariti AI" />
      <meta property="og:locale" content="en_GB" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        property="og:image"
        content="https://www.clariti.ai/images/logos/logo_brain_white_bg.png"
      />
      <meta
        name="twitter:image"
        content="https://www.clariti.ai/images/logos/logo_brain_white_bg.png"
      />
      <script type="application/ld+json">
        {JSON.stringify(orgSchema)}
      </script>
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>
    </Helmet>
  );
}

export default SeoDefaults;
